export enum PaintingStyle {
  fill = 1,
  stroke,
}
